import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {SelectItem} from "primeng/api";

@Pipe({
  name: 'translateDropdownStringList',
  standalone: true
})
export class TranslateDropdownStringListPipe implements PipeTransform {

  translateService = inject(TranslateService);
  transform(value: string[] | null, ...args: string[]): SelectItem[] | null {
    if(value) {
      return this.getDropdownTranslations(value, args[0])
    }
    return null;
  }

  public getDropdownTranslations(values: string[], path: string): any[] {
    const translations: any[] = [];
    if (values) {
      values.forEach(val => {
        this.translateService
          .get(path + '.' + val)
          .subscribe(res => {
            translations.push({value: val, label: res});
          });
      });
    }
    return translations;
  }

}
